
export { ShortProfile } from './short-profile';
